import Vue from 'vue'
import $ from 'jquery'
import Wire from '../../components/elct/cpts/wire/Wire.vue'
import WireGroup from '../../components/elct/cpts/wire/WireGroup.vue'

const ID_CANVAS = '#canvas'
const CN_VIEWPORT = '.svg-pan-zoom_viewport'
// const CN_WIREGROUP = '.wire-group'

const getPoint = function (target) {
  const svg = document.querySelector(ID_CANVAS)
  const panzoom = document.querySelector(CN_VIEWPORT)
  const rect = target.getBoundingClientRect()
  let pt = svg.createSVGPoint()
  pt.x = rect.x + rect.width / 2
  pt.y = rect.y + rect.height / 2
  pt = pt.matrixTransform(panzoom.getScreenCTM().inverse())
  return { x: pt.x, y: pt.y }
}

const getDifference = function (prev, curr) {
  const diff = {
    x: 0,
    y: 0
  }
  if (curr.x < prev.x) {
    diff.x = 5
  } else if (curr.x > prev.x) {
    diff.x = -5
  }
  if (curr.y < prev.y) {
    diff.y = +5
  } else if (curr.y > prev.y) {
    diff.y = -5
  }

  return diff
}

const getMousePosition = function (e) {
  if ($(ID_CANVAS)[0]) {
    // 실험 페이지일 경우
    const panzoom = document.querySelector(CN_VIEWPORT)
    const pt = { x: 0, y: 0 }
    const CTM = panzoom.getScreenCTM()
    pt.x = (e.clientX - CTM.e) / CTM.a
    pt.y = (e.clientY - CTM.f) / CTM.d

    if (state.helperWire) {
      // 임시 wire가 있으면
      // wire의 그래픽과 socket이 겹치지 않도록 wire의 길이를 짧게 조정
      const delta = getDifference(state.lastClickedElement.pt, pt)
      pt.x += delta.x
      pt.y += delta.y
      state.currentMousePoint.x = pt.x
      state.currentMousePoint.y = pt.y
    } else {
      state.currentMousePoint.x = pt.x
      state.currentMousePoint.y = pt.y // 예외처리 없으면 wire가 초기에 0,0으로 튐
    }
    return pt
  }
}
function drawGridLine (start, end) {
  // console.log('store wire: drawing wire')

  const line = document.querySelector('line.guide')
  line.setAttribute('x1', start.x)
  line.setAttribute('y1', start.y)
  line.setAttribute('x2', end.x)
  line.setAttribute('y2', end.y)
}
function updateHelperWire () {
  if (state.helperWire) {
    const trackingWires = state.helperWire.querySelectorAll('line') // 임시 wire에서 line 태그 전부 선택
    for (let i = 0; i < 2; i++) {
      trackingWires[i].x2.baseVal.value = state.currentMousePoint.x // line태그가 향하는 x,y좌표가 현재 마우스 좌표로 향하게 설정
      trackingWires[i].y2.baseVal.value = state.currentMousePoint.y // state.currentMousePoint는 getMousePosition()에 의해 조정됨
    }
    if (Math.abs(state.currentMousePoint.x - trackingWires[0].x1.baseVal.value) <= 2.0) {
      drawGridLine({ x: trackingWires[0].x1.baseVal.value, y: 0 }, { x: trackingWires[0].x1.baseVal.value, y: 4000 })
    } else if (Math.abs(state.currentMousePoint.y - trackingWires[0].y1.baseVal.value) <= 2.0) {
      drawGridLine({ x: 0, y: trackingWires[0].y1.baseVal.value }, { x: 4000, y: trackingWires[0].y1.baseVal.value })
    } else {
      drawGridLine({ x: 0, y: 0 }, { x: 0, y: 0 })
    }
  }
}

const updateElementAttribute = function (id, el1, el2, ax, ay) {
  if (!el1 || !el2) {
    console.warn('cant find elements', id, el1, el2)
    return
  }

  const EL = document.querySelector(`#${id}`)
  if (!EL) return { x: el1.getAttribute('x'), y: el1.getAttribute('y') }
  const pt = getPoint(EL)
  el1.setAttribute(ax, pt.x)
  el1.setAttribute(ay, pt.y)
  el2.setAttribute(ax, pt.x)
  el2.setAttribute(ay, pt.y)
  return pt
}

const getWireInstance = function (obj) {
  const ComponetClass = Vue.extend(Wire)
  const instance = new ComponetClass({
    propsData: { data: obj }
  })
  instance.$mount()
  return instance.$el
}

const getWireGroupInstance = function (vm, id, data) {
  const ComponetClass = Vue.extend(WireGroup)
  const instance = new ComponetClass({
    parent: vm,
    propsData: { id: id, wires: data }
  })
  instance.$mount()
  return instance.$el
}
const setMouseMoveEvent = function () {
  window.addEventListener('mousemove', getMousePosition)
  window.gsap.ticker.add(updateHelperWire)
}

setMouseMoveEvent()

const getWireColor = function (st, end) {
  const BLACK = 'rgb(0,0,0)'
  const RED = 'rgb(255,0,0)'
  const GREEN = 'rgb(0,128,0)'
  const stpin = st.substring(8)
  const enpin = end.substring(8)
  // console.log('getWireColor', st, stpin, end, enpin)
  if (stpin === 'MS' || enpin === 'MS') return BLACK
  else if (stpin.startsWith('MA') || enpin.startsWith('MA')) return RED
  else if (stpin.startsWith('M') || enpin.startsWith('M')) return BLACK
  else if (stpin.startsWith('CM') || enpin.startsWith('CM')) return BLACK
  else if (stpin === 'PS' || enpin === 'PS') return RED
  else if (stpin.startsWith('P') || enpin.startsWith('P')) return RED
  else if (stpin.startsWith('VI') || enpin.startsWith('VI')) return RED
  else return GREEN
}

const state = {
  clickedElct: null,
  lastClickedElement: null,
  currentWire: null,
  currentWireInfo: null,
  currentPoint: null,
  currentWireList: [],
  currentMousePoint: {
    x: 0,
    y: 0
  },
  wireList: [],
  count: 0,
  group: {
    list: {},
    id: 0
  },
  gElement: null,
  helperWire: null,
  cws: 'start' // currentWireStatus
}

const mutations = {
  createLines (state, el) {
    if (this.state.isSimulating) return
    setMouseMoveEvent()
    state.currentPoint = null
    const target = window.event.currentTarget

    if (!target) return
    if (target.classList.contains('terminal') || target.classList.contains('socket')) {
      state.currentPoint = getPoint(target)
      this.commit('wire/createGroupWires', { target, el, canvas: false })
    } else if (target.id === 'canvas' && state.lastClickedElement) {
      state.currentPoint = getMousePosition(window.event)
      this.commit('wire/createGroupWires', { target, el, canvas: true })
    }

    drawGridLine({ x: 0, y: 0 }, { x: 0, y: 0 })
  },
  createGroupWires (state, payload) {
    if (state.lastClickedElement) {
      state.count += 1
      state.currentWire = {
        id: payload.target.id,
        groupid: state.group.id,
        name: payload.el.name,
        pin: payload.el.pin ? payload.el.pin : payload.el.type,
        pt: state.currentPoint
      }
      state.currentWireList.push(state.currentWire)
      state.group.list[state.group.id] = state.currentWireList
      const size = state.currentWireList.length
      const color = getWireColor(state.currentWireList[0].pin, state.currentWireList[size - 1].pin)
      // console.log('wireColor', color)
      const obj = {
        id: state.count + 1,
        connection: {
          start: state.currentWireList[size - 2],
          end: state.currentWireList[size - 1]
        },
        color: color,
        points: [state.lastClickedElement.pt, state.currentPoint],
        group: {
          id: state.group.id,
          list: state.currentWireList
        }
      }
      state.currentWireInfo = obj
      const el = getWireInstance(obj)
      el.classList.add('temp')
      $(CN_VIEWPORT)[0].append(el)
      state.lastClickedElement = state.currentWire
      this.commit('wire/updateWireList')

      state.cws = payload.canvas ? 'drawing' : 'done'
      if (state.helperWire) state.helperWire.remove()
      state.helperWire = null
      if (payload.canvas) this.commit('wire/createHelperWire')
      if (state.cws === 'done') {
        this.commit('wire/drawAllLines')
      }
    } else {
      state.cws = 'start'
      state.count += 1
      state.currentWireInfo = null
      state.group.id = state.group.id + 1
      state.group.list[state.group.gid] = []
      state.currentWire = {
        id: payload.target.id,
        groupid: state.group.id,
        name: payload.el.name,
        pin: payload.el.pin,
        pt: state.currentPoint
      }
      state.lastClickedElement = { ...state.currentWire }
      state.currentWireList.push(state.currentWire)
      this.commit('wire/createHelperWire')
    }
  },
  deleteWireListById (state, groupId) {
    if (!state.group.list[groupId]) return
    const size = state.group.list[groupId].length
    const idx = state.wireList.findIndex(wire => Number(wire.group.id) === Number(groupId))
    state.wireList.splice(idx, size - 1)
    delete state.group.list[groupId]
  },
  drawAllLines (state) {
    // console.log('store/wire/drawAllLines', state.wireList)
    $('.temp').remove()
    let size = 1
    for (let i = 0; i < state.wireList.length; i += size - 1) {
      const obj = state.wireList[i]
      size = state.group.list[obj.group.id].length
      const v = this.$app.$children.findIndex((child) => child.$el.id === `wire-group${obj.group.id}`)
      if (v !== -1 || document.querySelector(`#wire-group${obj.group.id}`)) continue
      const groupEl = getWireGroupInstance(this.$app, obj.group.id, state.wireList.slice(i, i + size - 1))
      $(CN_VIEWPORT)[0].append(groupEl)
    }
    state.currentWire = state.lastClickedElement = null
    state.currentWireList = []
    if (state.helperWire) state.helperWire.remove()
    state.helperWire = null
  },
  recreateAllLines () {
    // console.log('mixins: line updated:', this.$store.state.wire.wireList)
    $('.wire-group').remove()
    let size = 1
    for (let i = 0; i < this.$store.state.wire.wireList.length; i += size - 1) {
      const obj = this.$store.state.wire.wireList[i]
      size = this.$store.state.wire.group.list[obj.group.id].length
      const WireElement = Vue.extend(WireGroup)
      const instance = new WireElement({
        propsData: {
          id: obj.group.id,
          wires: this.$store.state.wire.wireList.slice(i, i + size - 1)
        }
      })
      instance.$mount()
      $(CN_VIEWPORT)[0].append(instance.$el)
    }
  },
  createHelperWire (state) {
    const obj = {
      points: [
        state.currentWire.pt,
        state.currentWire.pt
      ]
    }
    const HelperWireClass = Vue.extend(Wire)
    const instance = new HelperWireClass({
      propsData: { data: obj }
    })
    instance.$mount()
    state.helperWire = instance.$el
    $(CN_VIEWPORT)[0].append(instance.$el)
  },
  selectAllWireGroups (state) {
    const wiregroups = document.querySelectorAll('.wire-group')
    wiregroups.forEach(el => {
      this.commit('elct/addSelectedElct', { el, id: el.id })
    })
  },
  styleSelectedWire (state, component) {
    const el = component.$el
    const obj = { el, id: el.id }
    el.classList.toggle('selected')
    if (el.classList.contains('selected')) {
      component.$data.selected = true
      this.commit('elct/addSelectedElct', obj)
    } else {
      component.$data.selected = false
      this.commit('elct/removeSelectedElct', obj)
    }
  },
  updateWireList (state) {
    if (!state.currentWireInfo) return
    state.wireList = [...state.wireList, state.currentWireInfo]
  },
  updateLines (state) {
    const lines = state.wireList
    const borders = document.querySelectorAll('.wire-border')
    const wires = document.querySelectorAll('.wire')
    if (!wires.length || !lines.length) return
    for (let i = 0; i < lines.length; i++) {
      const item = wires[i]
      let st = lines[i].connection.start.id
      let end = lines[i].connection.end.id

      st = st.charAt(st.length - 1) === '+' ? st.slice(0, -1) + '\\+' : st
      end = end.charAt(end.length - 1) === '+' ? end.slice(0, -1) + '\\+' : end
      try {
        if (st !== 'canvas' && end === 'canvas') {
          const npt = updateElementAttribute(st, item, borders[i], 'x1', 'y1')
          lines[i].connection.start.pt.x = npt.x
          lines[i].connection.start.pt.y = npt.y
        } else if (st === 'canvas' && end !== 'canvas') {
          const npt = updateElementAttribute(end, item, borders[i], 'x2', 'y2')
          lines[i].connection.end.pt.x = npt.x
          lines[i].connection.end.pt.y = npt.y
        } else if (st !== 'canvas' && end !== 'canvas') {
          const nxpt = updateElementAttribute(st, item, borders[i], 'x1', 'y1')
          const nypt = updateElementAttribute(end, item, borders[i], 'x2', 'y2')
          lines[i].connection.start.pt.x = nxpt.x
          lines[i].connection.start.pt.y = nxpt.y
          lines[i].connection.end.pt.x = nypt.x
          lines[i].connection.end.pt.y = nypt.y
        }
      } catch (error) {
        console.warn(error)
      }
    }
  },
  updateWireColor (state, color) {
    const selected = this.state.elct.selected.list
    const wireList = state.wireList
    const rgba = color.rgba
    selected.forEach(item => {
      if (item.id.startsWith('wire-group')) {
        const wires = item.el.querySelectorAll('g')
        wires.forEach(wire => {
          wire.querySelector('.wire').style.stroke = color.hex
          wire.querySelector('.wire-border').style.stroke = color.hex
        })
        const id = Number(item.id.substring(10))
        const idx = wireList.findIndex((wire) => wire.group.id === id)
        for (let i = idx; i < idx + wires.length; i++) {
          wireList[i].color = `rgb(${rgba.r}, ${rgba.g}, ${rgba.b})`
        }
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
